/* @flow */

import React from 'react';
import { Header, Message } from 'semantic-ui-react';

type Props = {
  block: EditorialTextBlock,
};

const View = ({ block }: Props) => {
  if (block.content) {
    return (
      <Header as={block.level || 'h1'} textAlign="center">
        {block.content}
      </Header>
    );
  }

  return <Message icon="info" header="Aucun titre spécifié" />;
};

export default View;



// WEBPACK FOOTER //
// ./src/modules/edito/plugins/title/View.js